import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  CardTitle,
  CardSubtitle,
  Table,
  Form
} from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";

import "../../styles/estilos.css";
import Page from "components/Page";
import { fetchGuardarCarritoFinanciero } from "../../redux/actions/aRamoLineaFinanciera";
import { encriptarTramaAES } from "../../utils/Encriptar/index"

class CotizacionFinanciero3 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listDeducibles: [],
      listLimites: []
    };
    this.selectClick = this.selectClick.bind(this);
    this.selectedColor = this.selectedColor.bind(this);
  }

  selectClick = async params => {
    const { limiteCodigo, limDescripcion, limDeducible, limPrima } = params;

    //construir objeto para post
    const datosJSON = {
      idCarrito: this.props.detalleCarrito.ultimoPaso.resultado.idCarrito,
      limCodigoCore: limiteCodigo,
      limDescripcion: limDescripcion,
      limDeducible: limDeducible,
      limPrima: limPrima
    }
    const datosJSON2 = {
      paso: "3",
      prima: datosJSON
    }
    const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON2));
    await this.props.guardarCarrito({ "Data": Buffer.from(JSON.stringify(encriptado)).toString('base64') });

    this.props.history.push({
      pathname: "/resumen-cotizacion-financiero"
    });
  }

  componentWillUnmount(){
   this.setState({
    listDeducibles: [],
    listLimites: []
   })
  }
  
  componentDidMount() {

    console.log('verEstado: ', this.props.limitesFinanciero.listarLimites.lista)
    var group = groupByKey(this.props.limitesFinanciero.listarLimites.lista, 'limDeducible')
    var group2 = groupByKey(this.props.limitesFinanciero.listarLimites.lista, 'limDescripcion')


    var aux = [];
    for (const key in group) {
      const element = { titulo: key, valores: group[key] };
      aux.push(element)
    }
    var aux2 = [];
    for (const key in group2) {
      const element = { titulo: key, valores: group2[key] };
      aux2.push(element)
    }

    var keys = []

    for (const key in group) {

      const element = { id: key, value: group[key] };

      keys.push(element)



    }


    this.setState({
      listDeducibles: aux,
      listLimites: aux2
    })
    window.scroll(0, 0);

  }

  obtenerPrima(cobertura, limite) {

    const { limitesFinanciero } = this.props;



    var limiteEncontrado = limitesFinanciero.listarLimites.lista.find(lim => lim.limDeducible == limite && lim.limDescripcion == cobertura)

    return limiteEncontrado
  }

  /**
   * 
   * @param {string} limCodigo Lim codigo core del limite
   * @return {string} color El color para el elemento seleccionado
   */
  selectedColor(limCodigo) {
    let color = ''
    if (this.props.preservar === 'si') {
      color = this.props.detalleCarrito.limites.limCodigoCore === limCodigo ? 'rgb(175, 0, 110)' : ''
    }
    return color
  }

  render() {
    const { respuestaCarrito, limitesFinanciero, detalleCarrito } = this.props;

    return (
      <LoadingScreen
        loading={respuestaCarrito.guardarCarritoFinancieroIsLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Guardando información. Por favor espere..."
      >
        <Page
          title={detalleCarrito.carDescripcionSeguro}
          breadcrumbs={[{ name: `${detalleCarrito.carDescripcionSeguro}`, active: true }]}
        >
          <div className="container-step ">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>


          {
            this.state.listDeducibles !== undefined && <div>

              <Row>
                <Col xs={5} sm={6} md={3} lg={2} xl={2}>
                  <Table borderless size={'lg'}>
                    <thead>
                      <tr>
                        <th>
                          <div className="div-align-center" style={{ backgroundColor: "#a8a8aa", width: '150px' }}>
                            <p style={{ color: "#001871", textAlign: "center" }} >{'Límite Anual'}</p>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>

                      {this.state.listLimites.map(valor => {
                        return (
                          <tr>
                            <th>
                              <div className="div-align-center" style={{ backgroundColor: "#d1d0ce", width: '150px' }}>
                                <p style={{ textAlign: "center", }} >{'$' + valor.titulo}</p>
                              </div>
                            </th>
                          </tr>
                        )
                      })}



                    </tbody>
                  </Table>
                </Col>
                <Col xs={7} sm={6} md={9} lg={10} xl={10}>
                  <Form style={{ width: "100%" }} >
                    {this.state.listDeducibles && (
                      <Table borderless responsive size={'lg'}>
                        <thead>
                          <tr>

                            {this.state.listDeducibles.map(plan => {

                              return (
                                <th  >
                                  <div className="div-align-center" style={{ backgroundColor: "#001871", width: '200px' }}>
                                    <p style={{ color: `#ffffff`, textAlign: "center", textTransform: "uppercase" }} >{'Deducible $' + plan.titulo}</p>
                                  </div>

                                </th>
                              )

                            })}





                          </tr>
                        </thead>
                        <tbody>

                          {
                            this.state.listLimites.map(cobertura => {
                              return (
                                <tr>
                                  {this.state.listDeducibles.map(valor => {
                                    return (
                                      <td>

                                        {this.obtenerPrima(cobertura.titulo, valor.titulo) ?
                                          <Button className="div-align-center btn btn-primary" onClick={() => {
                                            this.selectClick({ limiteCodigo: this.obtenerPrima(cobertura.titulo, valor.titulo).limCodigoCore, limDescripcion: this.obtenerPrima(cobertura.titulo, valor.titulo).limDescripcion, limDeducible: this.obtenerPrima(cobertura.titulo, valor.titulo).limDeducible, limPrima: this.obtenerPrima(cobertura.titulo, valor.titulo).limPrima })
                                          }}
                                            style={{
                                              width: '200px',
                                              height:'45.56px',
                                              display: "block", margin: "auto", backgroundColor: this.selectedColor(this.obtenerPrima(cobertura.titulo, valor.titulo).limCodigoCore),
                                              borderColor: this.selectedColor(this.obtenerPrima(cobertura.titulo, valor.titulo).limCodigoCore), boxShadow: this.selectedColor(this.obtenerPrima(cobertura.titulo, valor.titulo).limCodigoCore).length > 0 ? '0 5px gray' : '',
                                              transform: this.selectedColor(this.obtenerPrima(cobertura.titulo, valor.titulo).limCodigoCore).length > 0 ? 'translateY(2px)' : ''
                                            }}>
                                            <p style={{ textAlign: "center" }} >{'Prima USD $' + this.obtenerPrima(cobertura.titulo, valor.titulo).limPrima}</p>
                                          </Button>
                                          :
                                          <div className="div-align-center" style={{ backgroundColor: "#F0F0EB", width: '200px' }}>
                                            <p style={{ textAlign: "center" }} >{'No aplica'}</p>
                                          </div>
                                        }


                                      </td>
                                    )
                                  })}



                                </tr>
                              )
                            })
                          }






                        </tbody>
                      </Table>
                    )}
                  </Form>


                </Col>

              </Row>
            </div>
          }


       


          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <Row style={{ margin: "3px" }}>
                    <h5 style={{ fontWeight: "large" }}>Nota: Las primas no incluyen IVA ni gastos de exedición.</h5>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <Row style={{}}>
                    <Col class="mt-3">
                      <Button className="btn btn-detail-gray" onClick={() => this.props.handleBack()} style={{ marginTop: "0.7rem", marginLeft: "0.4rem" }}  >
                        <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"   REGRESAR"}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Page>
      </LoadingScreen>
    );
  }
}

function groupByKey(array, key) {
  return array
    .reduce((hash, obj) => {
      if (obj[key] === undefined) return hash;
      return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
    }, {})
}

const mapStateToProps = state => ({
  respuestaCarrito: state.datosCotizacionFinanciero
});
const mapDispatchToProps = dispatch => {
  return {
    guardarCarrito: (data) => dispatch(fetchGuardarCarritoFinanciero(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionFinanciero3)
);
